import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

const initialForm = {
  name: "",
};

export default function StoreSectionFormModal({
  open,
  onClose,
  onSubmit,
  section,
  loading,
}) {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!open) {
      setForm(initialForm);
      setErrors({});
      return;
    }

    if (section) {
      setForm({
        name: section.name || "",
      });
    } else {
      setForm(initialForm);
    }

    setErrors({});
  }, [open, section]);

  const handleChange = (field) => (event) => {
    const value = event.target.value;

    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
      general: "",
    }));
  };

  const validate = () => {
    const nextErrors = {};

    if (!form.name.trim()) {
      nextErrors.name = "Ingresa el nombre de la sección";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    const result = await onSubmit({
      name: form.name.trim(),
    });

    if (!result?.ok) {
      setErrors((prev) => ({
        ...prev,
        general: result?.error || "No se pudo guardar la sección",
      }));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: "24px",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          px: 2.2,
          pt: 2,
          pb: 1,
          color: "#111827",
          fontSize: 20,
          fontWeight: 800,
        }}
      >
        {section ? "Editar sección" : "Nueva sección"}
      </DialogTitle>

      <DialogContent sx={{ px: 2.2, pt: "10px !important", pb: 1 }}>
        <Stack spacing={1.6}>
          <Typography
            sx={{
              color: "#6b7280",
              fontSize: 13.3,
              fontWeight: 500,
            }}
          >
            Define una nueva sección para organizar el catálogo de NovaXFit Store.
          </Typography>

          <TextField
            label="Nombre"
            value={form.name}
            onChange={handleChange("name")}
            fullWidth
            size="small"
            error={Boolean(errors.name)}
            helperText={errors.name || " "}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                bgcolor: "#ffffff",
              },
            }}
          />

          {errors.general ? (
            <Typography
              sx={{
                color: "#b91c1c",
                fontSize: 13,
                fontWeight: 600,
              }}
            >
              {errors.general}
            </Typography>
          ) : null}
        </Stack>
      </DialogContent>

      <DialogActions
        sx={{
          px: 2.2,
          pb: 2,
          pt: 1,
          gap: 1,
        }}
      >
        <Button
          onClick={() => onClose()}
          disabled={loading}
          variant="outlined"
          sx={{
            minWidth: 110,
            height: 38,
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 700,
            color: "#334155",
            borderColor: "rgba(51,65,85,0.18)",
            "&:hover": {
              borderColor: "rgba(51,65,85,0.28)",
              bgcolor: "#f8fafc",
            },
          }}
        >
          Cancelar
        </Button>

        <Button
          onClick={handleSubmit}
          disabled={loading}
          variant="contained"
          sx={{
            minWidth: 140,
            height: 38,
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 700,
            bgcolor: "#0f172a",
            boxShadow: "none",
            "&:hover": {
              bgcolor: "#111827",
              boxShadow: "none",
            },
          }}
        >
          {loading ? "Guardando..." : section ? "Guardar cambios" : "Crear sección"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}